import React, { useState, useMemo, useCallback } from 'react';
import styles from './TimezoneNotice.module.css';

export default function() {
	const timezoneOffset = useMemo(() => new Date().getTimezoneOffset(), []);
	const timezoneName = useMemo(() => Intl.DateTimeFormat().resolvedOptions().timeZone, []);

	const [showNotice, setShowNotice] = useState(true);
	const closeNotice = useCallback(() => setShowNotice(false), []);

	// if user closed the notice, don't show notice
	if(!showNotice) { return null }
	
	// If user is in Asia/Bangkok timezone, don't show notice
	if(timezoneOffset === -420) { return null }

	// user is now in different timezone, show notice
	return (
		<div className={`alert text-center cookiealert show ${styles.notice}`} role="alert">
			<b>You are not in "Indochina" timezone</b> 😃 We notice that you use the timezone <b>{timezoneName}</b>, please be aware that all date/time you see on this website is formatted in "Indochina" timezone (UTC+07:00)
			<button onClick={closeNotice} type="button" className={`btn btn-primary btn-sm ${styles.button}`}>
				Close
			</button>
		</div>
	);
}